import {useAppSelector} from "../../../redux/store";
import {Content, MainContentContainer} from "../../styled";
import {Sidebar} from "../../../pages/sidebar";
import {Outlet} from "react-router-dom";
import {Footer} from "../../../pages/footer/footer";
import React from "react";
import PaymentResult from "../../../pages/info/payment-result";
import {globalHeaderRef} from "../../../pages/shared/refs";

export const InfoRoutes = {
    path: 'info',
    Component: () => {
        const {isOpen} = useAppSelector(state => state.sidebarReducer);
        const {matchesTablet, matchesPc} = useAppSelector(state => state.deviceReducer);

        return (
            <MainContentContainer>
                <Sidebar headerRef={globalHeaderRef}/>

                <Content style={{
                    paddingLeft: isOpen
                    && (matchesTablet || matchesPc) ? '15rem' : 'unset'
                }}>
                    <Outlet/>

                    <Footer/>
                </Content>
            </MainContentContainer>
        )
    },
    children: [
        {
            path: 'payment',
            index: true,
            element: <PaymentResult/>
        }
    ]
}
